import { DOMAIN } from 'queries/domain';
import { makeApolloClient, logError } from '../util';
import { SET_DOMAIN, DELETE_DOMAIN } from './actionTypes';

export const setDomain = (domain, from) => ({
	type: SET_DOMAIN,
	domain,
	from,
});

export const thunkFetchDomain = (id, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { domain } = await client.request(DOMAIN, { id });
		dispatch(setDomain(domain, from));
	} catch (error) {
		logError(error, 'domain.actions.thunkFetchDomain');
	}
};
export const deleteDomain = domainIDClientID => ({
	type: DELETE_DOMAIN,
	domainIDClientID,
});
